import { BarController, BarElement, CategoryScale, Chart, Legend, LinearScale, Title, Tooltip } from 'chart.js';
import JsPDF from 'jspdf';

Chart.register(BarController, BarElement, CategoryScale, LinearScale, Tooltip, Legend, Title);

export const generateStudentReportPdf = (data: any) => {
  const doc = new JsPDF({ unit: 'mm' });

  const pageWidth = doc.internal.pageSize.getWidth();
  const headerHeight = 50;
  const headerY = 10;

  doc.setFillColor(139, 23, 57);
  doc.rect(0, headerY - 5, pageWidth, headerHeight + 10, 'F');

  const fontSizeTitle = 14;
  const margin = 15;
  let cursorY = 80;

  doc.setFont('times', 'bold').setFontSize(fontSizeTitle);
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(35);
  doc.text('FUSION CENTER', margin, headerY + 30);

  data.forEach((obj: any) => {
    if (obj.header) {
      const height = 12;
      doc.setFillColor(139, 23, 57);
      doc.rect(0, cursorY, pageWidth, height, 'F');
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(14);
      doc.setFont('times', 'bold');
      doc.text(obj.header.toUpperCase(), margin, cursorY + 8);

      cursorY += height + 8;
    }

    if (obj.title) {
      doc.setTextColor(139, 23, 57);
      doc.setFontSize(12);
      doc.setFont('times', 'bold');
      doc.text(obj.title, margin, cursorY + 2);
      cursorY += 8;
    }

    if (obj.content) {
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(11);
      doc.setFont('times', 'medium');

      // const textLines = doc.splitTextToSize(obj.content, pageWidth - 2 * margin);
      // doc.text(textLines, margin, cursorY);
      const y = drawFormattedText(doc, obj.content, margin, cursorY, pageWidth - 2 * margin);
      cursorY = y;
      // cursorY += textLines.length * 7;
    }

    if (cursorY > doc.internal.pageSize.getHeight() - 30) {
      doc.addPage();
      cursorY = 20;
    }

    if (obj.graphs.length) {
      const graphWidth = (pageWidth - 3 * margin) / 2;
      const graphHeight = graphWidth * 0.5;

      let cursorX = margin;

      obj.graphs.forEach((graph: any, idx: number) => {
        const canvas = document.createElement('canvas');
        canvas.width = 600;
        canvas.height = 300;

        const chart = new Chart(canvas, {
          type: 'bar',
          data: {
            labels: graph.data.map((d: any) => d.label),
            datasets: [
              {
                label: graph.title,
                data: graph.data.map((d: any) => d.value),
                backgroundColor: graph.data.map((d: any) => 'rgb(139, 23, 57)'),
              },
            ],
          },
          options: {
            responsive: false,
            animation: false,
          },
        });

        const chartImage = canvas.toDataURL('image/png');

        if (cursorY > doc.internal.pageSize.getHeight() - 30) {
          doc.addPage();
          cursorY = 20;
          cursorX = margin;
        }

        doc.addImage(chartImage, 'PNG', cursorX, cursorY, graphWidth, graphHeight);
        chart.destroy();

        if ((idx + 1) % 2 === 0) {
          cursorX = margin;
          cursorY += graphHeight + 10;
        } else {
          cursorX += graphWidth + margin;
        }
      });
      cursorY += graphHeight + 10;
    }
  });
  return doc;
};

const drawFormattedText = (doc: any, content: string, x: number, y: number, maxWidth: number, lineHeight = 5) => {
  const regex = /\*\*(.+?)\*\*|([^*]+)/g;
  let match;
  let currentX = x;

  // eslint-disable-next-line no-cond-assign
  while ((match = regex.exec(content)) !== null) {
    const text = match[1] || match[2];
    const isBold = !!match[1];

    doc.setFont('times', isBold ? 'bold' : 'normal');

    const lines = doc.splitTextToSize(text, maxWidth);

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];

      if (currentX !== x && i > 0) {
        // eslint-disable-next-line no-param-reassign
        y += lineHeight;
        currentX = x;
      }

      doc.text(line, currentX, y);
      currentX += doc.getTextWidth(line);
    }
  }
  return y + 15;
};
